<template>
  <div class="flex items-center h-full">
    <icon
      v-if="statusIcon"
      :icon="statusIcon"
      :size="IconSize.SM"
      :style="{ color: statusColor }"
      class="mr-2 flex-shrink-0"
    />
    <span class="overflow-hidden text-ellipsis">
      {{ title }}
    </span>
  </div>
</template>

<script>
import { mdiAlertOutline, mdiAlertOctagonOutline } from '@mdi/js';
import { Icon, IconSize } from '@/components/Icon';
import { SurveyStatus } from '@/api/v2/requests/surveys';
import { surveyStatusStyles } from '@/views/Brand/Surveys/_constants/survey-status';

export default {
  name: 'SurveyTitleCell',
  components: {
    Icon,
  },
  data() {
    return {
      IconSize,
    };
  },
  computed: {
    title() {
      return this.params?.data?.title || '';
    },
    status() {
      return this.params?.data?.aggregatedStatus;
    },
    statusIcon() {
      if (this.status === SurveyStatus.NEEDS_REVISION) {
        return mdiAlertOutline;
      } else if (this.status === SurveyStatus.REJECTED) {
        return mdiAlertOctagonOutline;
      }
      return null;
    },
    statusColor() {
      if (this.status === SurveyStatus.NEEDS_REVISION) {
        return surveyStatusStyles[SurveyStatus.NEEDS_REVISION]?.color;
      } else if (this.status === SurveyStatus.REJECTED) {
        return surveyStatusStyles[SurveyStatus.REJECTED]?.color;
      }
      return null;
    },
  },
};
</script>
